import { Donation, Designation } from "../../types"
import { css } from "@emotion/react"
import { Badge, Heading } from "@planningcenter/doxy-web"
import { formattedCents } from "source/giving/utils/money"
import { dateStampStringToLocal } from "source/giving/donate/form/utils/frequency"
import { useGivingPersonContext } from "../../hooks/useGivingPersonContext"
import { capitalize } from "lodash"
import { Link } from "react-router-dom"
import PaymentMethodPresenter from "./PaymentMethodPresenter"

interface DonationDetailsProps {
  donation: Donation
}

export default function DonationDetails({ donation }: DonationDetailsProps) {
  const { givingPerson } = useGivingPersonContext()

  const donationTotal = formattedCents(donation.amount_cents)

  return (
    <div className="d-f fd-c g-2">
      <div className="d-f fd-c g-1 action-drawer mb-2">
        <div className="d-f fd-c g-4p">
          <div className="d-f ai-c jc-sb g-1">
            <Heading
              level={3}
              size={4}
              text={dateStampStringToLocal(donation.received_at)}
              color="tint1"
            />
            <div className="d-f ai-c g-1">
              {donation.refunded ? (
                <Badge text="Refunded" theme="error" />
              ) : (
                donation.failed_at && <Badge text="Failed" theme="error" />
              )}
              {donation.payment_status === "pending" && (
                <Badge text="In transit" theme="warning" />
              )}
              {donation.awaiting_verification ? (
                <Badge text="Awaiting verification" theme="warning" />
              ) : (
                !donation.processed_at && (
                  <Badge text="Awaiting transit" theme="warning" />
                )
              )}
              <span
                className={`fw-600 ${donation.refunded || donation.failed_at ? "c-ruby" : ""}`}
              >
                {donationTotal}
              </span>
            </div>
          </div>
        </div>
        {donation.designations.map((designation: Designation) => {
          return (
            <div
              className="d-f ai-b jc-sb g-1 fs-4 c-tint2"
              key={designation.id}
            >
              <div
                className="d-f ai-b fw-w nw-0"
                css={css`
                  row-gap: 2px;
                `}
              >
                <span className="d-b badge truncate">
                  {designation.fund.name}
                </span>
                {givingPerson.has_joint_giver && (
                  <span
                    css={css`
                      padding-left: 6px; // align with badge when wrapped
                    `}
                  >
                    {donation.person.first_name} {donation.person.last_name}
                  </span>
                )}
              </div>
              {donation.designations.length > 1 && (
                <div>
                  {formattedCents(parseFloat(designation.amount) * 100)}
                </div>
              )}
            </div>
          )
        })}
        <PaymentMethodPresenter donation={donation} />
        {donation.tax_deductible === false && (
          <div className="fs-4">
            {capitalize(donation.payment_source.type)}:{" "}
            {donation.payment_source.name} | Nondeductible
          </div>
        )}
        {donation.awaiting_verification && (
          <Link to="/me/profile/payment-methods" className="fs-13 fw-500">
            Verify bank account
          </Link>
        )}
      </div>
    </div>
  )
}
